// extracted by mini-css-extract-plugin
module.exports = {"detailPanel":"antd-pro-pages-editor-koni-components-editor-detail-panel-index-detailPanel"};